import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCustomMetricsTrialWarning = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["custom-metrics-trial-warning", userId],
    queryFn: async () => {
      if (!userId) return false;

      const { data, error } = await supabase.rpc("should_show_custom_metrics_trial_warning", {
        p_user_id: userId,
      });
      if (error) throw error;
      return data as boolean;
    },
    enabled: !!userId,
    refetchInterval: 60000, // Check every minute
  });
};
